module.exports = __webpack_public_path__ + "img/spirit_460.2291016d.png";